import React, { useState, useEffect, ReactNode } from "react";
import { Modal } from "../../../components/common";
import { ChangePasswordForm } from "../../forms/settings/ChangePasswordForm";
import { useChangePasswordMutation } from "../../../store/services/user";
import { selectCurrentUser } from "../../../store/reducers/user";
import { useSelector } from "react-redux";
import { VerifyModal } from "../../../components/modals";
import { toastSuccess } from "../../../utils/toasts";
import { useFormErrors } from "../../../hooks/useFormErrors";

type Props = {
  children: (fn: () => void) => ReactNode;
};

type Inputs = {
  new_password: string;
  current_password: string;
  code?: string;
};

export const ChangePasswordModal: React.FC<Props> = (props) => {
  const { is_2fa_enabled } = useSelector(selectCurrentUser);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2FA, setIsOpen2FA] = useState<boolean>(false);
  const [formData, setFormData] = useState<Inputs>({
    new_password: "",
    current_password: "",
  });

  const { children } = props;

  const [changePassword, { isSuccess, isLoading, isError, error }] =
    useChangePasswordMutation();

  const formErrors = useFormErrors(isError, error, {
    defaultValues: !isOpen && !isOpen2FA ? [] : undefined,
    onError: () => {
      setIsOpen(true);
      setIsOpen2FA(false);
    },
  });

  const actionHandler = () => setIsOpen(true);

  const tfaPassubmit = async (data: Inputs) => {
    if (is_2fa_enabled) {
      setFormData(data);
      setIsOpen(false);
      setIsOpen2FA(true);
    } else {
      await changePassword(data);
    }
  };

  const tfaVerifySubmit = async (args: Inputs) => {
    await changePassword({
      ...formData,
      ...args,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      setIsOpen2FA(false);
      setIsOpen(false);
      toastSuccess("Password updated");
    }
  }, [isLoading, isSuccess]);

  return (
    <>
      {children(actionHandler)}

      <Modal
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        title="Change password"
        subtitle="Please enter the current and a new password."
      >
        <ChangePasswordForm submit={tfaPassubmit} formErrors={formErrors} />
      </Modal>

      {isOpen2FA && (
        <VerifyModal
          action={tfaVerifySubmit}
          open={isOpen2FA}
          changeOpen={setIsOpen2FA}
          formErrors={formErrors}
        />
      )}
    </>
  );
};
